import { App, inject, InjectionKey } from 'vue';

// Define the type for pageContext
export type PageContext = {
  routeParams: Record<string, string>;
  urlParsed: { search: URLSearchParams | [] };
  urlPathname: string;
  urlOriginal: string;
  [key: string]: unknown;
  Page: any;
  pageProps: Record<string, unknown>;
  initialStoreState?: any;
};

// Create a typed injection key
const PageContextKey: InjectionKey<PageContext> = Symbol('PageContext');

/**
 * Composable to access pageContext in any Vue component
 */
export function usePageContext(): PageContext | null {
  const pageContext = inject(PageContextKey);

  return pageContext ?? null;
}

/**
 * Set the pageContext in the Vue app instance
 */
export function setPageContext(app: App, pageContext: PageContext): void {
  app.provide(PageContextKey, pageContext);
}
